/**
 * TML Signup Modal Handler
 * Consolidated script for handling TML Direct Access signup form popups
 * Used by: main-product, kit-product, category-grid, direct-access-sidebar
 */
(function() {
  'use strict';

  function initTmlSignupModals() {
    // Find all modal triggers with data-modal-id attribute
    const triggers = document.querySelectorAll('[data-modal-id]');
    
    // Find all triggers with data-open-tml-signup attribute (category grid style)
    const categoryTriggers = document.querySelectorAll('[data-open-tml-signup]');

    // Handle data-modal-id triggers (product pages)
    triggers.forEach(function(trigger) {
      const modalId = trigger.getAttribute('data-modal-id');
      const modal = document.getElementById(modalId);
      const overlayId = modalId.replace('tml-signup-modal-', 'tml-signup-overlay-');
      const overlay = document.getElementById(overlayId);
      
      if (modal && overlay) {
        // Move modal and overlay to body for proper z-index stacking
        if (modal.parentNode !== document.body) {
          document.body.appendChild(overlay);
          document.body.appendChild(modal);
        }
        
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          openModal(modal, overlay);
        });
        
        setupModalClose(modal, overlay);
      }
    });

    // Handle data-open-tml-signup triggers (category grid)
    const sectionIds = new Set();
    categoryTriggers.forEach(function(trigger) {
      sectionIds.add(trigger.getAttribute('data-open-tml-signup'));
    });

    sectionIds.forEach(function(sectionId) {
      const modal = document.getElementById('tml-signup-modal-' + sectionId);
      const overlay = document.getElementById('tml-signup-overlay-' + sectionId);
      const btns = document.querySelectorAll('[data-open-tml-signup="' + sectionId + '"]');
      
      if (modal && overlay) {
        // Move modal and overlay to body for proper z-index stacking
        if (modal.parentNode !== document.body) {
          document.body.appendChild(overlay);
          document.body.appendChild(modal);
        }
        
        btns.forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            openModal(modal, overlay);
          });
        });
        
        setupModalClose(modal, overlay);
      }
    });
  }

  function openModal(modal, overlay) {
    if (modal && overlay) {
      modal.classList.add('active');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('tml-modal-active');
    }
  }

  // Helper function to check if popup should be prevented from closing
  function shouldPreventClose(modal) {
    if (!modal) return false;
    const formWrapper = modal.querySelector('[data-prevent-close="true"]');
    return !!formWrapper;
  }

  function closeModal(modal, overlay) {
    // Check if form has messages that prevent closing
    if (shouldPreventClose(modal)) {
      return; // Don't close if there are error/success messages
    }
    
    if (modal && overlay) {
      modal.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      document.body.classList.remove('tml-modal-active');
    }
  }

  function setupModalClose(modal, overlay) {
    // Close on overlay click
    overlay.addEventListener('click', function() {
      if (!shouldPreventClose(modal)) {
        closeModal(modal, overlay);
      }
    });
    
    // Close on close button click (supports multiple selectors)
    const closeBtn = modal.querySelector('.tml-close-btn, [data-tml-close-form]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        if (shouldPreventClose(modal)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
        closeModal(modal, overlay);
      });
    }
    
    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        if (!shouldPreventClose(modal)) {
          closeModal(modal, overlay);
        }
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTmlSignupModals);
  } else {
    initTmlSignupModals();
  }

  // Re-initialize when Shopify section is re-rendered (for theme editor)
  document.addEventListener('shopify:section:load', initTmlSignupModals);
})();

